import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import {AssetVersionPipe} from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-search-bar',
  imports: [ReactiveFormsModule, CommonModule, AssetVersionPipe],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent implements AfterViewInit {
  @Input() placeholder: string = 'Search...';
  @Input() searchControl = new FormControl('');
  // Focus the input on render so the user can type immediately (e.g. the management tables)
  @Input() autoFocus = false;
  @Output() onSubmitSearch = new EventEmitter<string>();
  @ViewChild('searchInput') private searchInput?: ElementRef<HTMLInputElement>;

  ngAfterViewInit(): void {
    if (this.autoFocus) {
      this.focus();
    }
  }

  /** Programmatic focus — e.g. the management screen refocuses on every tab switch. */
  public focus(): void {
    this.searchInput?.nativeElement.focus();
  }

  private valueChangeSub?: Subscription;
  private timeout?: any;

  ngOnInit() {
    this.valueChangeSub = this.searchControl.valueChanges
    .subscribe(value => {
      if (value === '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.submitSearch();
        }, 1000);
      } else {
        clearTimeout(this.timeout);
      }
    });
  }

  submitSearch() {
    clearTimeout(this.timeout);
    this.onSubmitSearch.emit(this.searchControl.value as string);
  }

  ngOnDestroy() {
    this.valueChangeSub?.unsubscribe();
    clearTimeout(this.timeout);
  }
}
